import { render, staticRenderFns } from "./CarouselComponent.vue?vue&type=template&id=a68e4b86"
import script from "./CarouselComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CarouselComponent.vue?vue&type=style&index=0&id=a68e4b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports